export default {
    en: {
        sendInvite: 'Send invite for ',
        sendInviteBtn: 'Send invite',
        yourTasks: 'Your tasks ',
        welcomeTo: 'Welcome to ',
    },
    in: {
        sendInvite: 'Kirim undangan untuk ',
        sendInviteBtn: 'Kirim undangan',
        yourTasks: 'Tugas Anda ',
        welcomeTo: 'Selamat datang di ',
    },
    zh: {
        sendInvite: '发送邀请给 ',
        sendInviteBtn: '发送邀请',
        yourTasks: '您的任务 ',
        welcomeTo: '欢迎来到 ',
    },
    nl: {
        sendInvite: 'Uitnodiging sturen voor ',
        sendInviteBtn: 'Uitnodiging sturen',
        yourTasks: 'Uw taken ',
        welcomeTo: 'Welkom bij ',
    },
    fi: {
        sendInvite: 'Lähetä kutsu ',
        sendInviteBtn: 'Lähetä kutsu',
        yourTasks: 'Tehtäväsi ',
        welcomeTo: 'Tervetuloa ',
    },
    fr: {
        sendInvite: 'Envoyer une invitation pour ',
        sendInviteBtn: 'Envoyer une invitation',
        yourTasks: 'Vos tâches ',
        welcomeTo: 'Bienvenue à ',
    },
    de: {
        sendInvite: 'Einladung senden für ',
        sendInviteBtn: 'Einladung senden',
        yourTasks: 'Ihre Aufgaben ',
        welcomeTo: 'Willkommen bei ',
    },
    hi: {
        sendInvite: 'निमंत्रण भेजें ',
        sendInviteBtn: 'निमंत्रण भेजें',
        yourTasks: 'आपके कार्य ',
        welcomeTo: 'स्वागत है ',
    },
    it: {
        sendInvite: 'Invia invito per ',
        sendInviteBtn: 'Invia invito',
        yourTasks: 'I tuoi compiti ',
        welcomeTo: 'Benvenuto a ',
    },
    ja: {
        sendInvite: '招待を送信する: ',
        sendInviteBtn: '招待を送信',
        yourTasks: 'あなたのタスク ',
        welcomeTo: 'へようこそ ',
    },
    ko: {
        sendInvite: '초대 보내기 ',
        sendInviteBtn: '초대 보내기',
        yourTasks: '당신의 작업 ',
        welcomeTo: '에 오신 것을 환영합니다 ',
    },
    pl: {
        sendInvite: 'Wyślij zaproszenie dla ',
        sendInviteBtn: 'Wyślij zaproszenie',
        yourTasks: 'Twoje zadania ',
        welcomeTo: 'Witamy w ',
    },
    pt: {
        sendInvite: 'Enviar convite para ',
        sendInviteBtn: 'Enviar convite',
        yourTasks: 'As suas tarefas ',
        welcomeTo: 'Bem-vindo a ',
    },
    es: {
        sendInvite: 'Enviar invitación para ',
        sendInviteBtn: 'Enviar invitación',
        yourTasks: 'Tus tareas ',
        welcomeTo: 'Bienvenido a ',
    },
    tr: {
        sendInvite: 'Davet gönder ',
        sendInviteBtn: 'Davet gönder',
        yourTasks: 'Görevlerin ',
        welcomeTo: 'Hoş geldiniz ',
    },
    vi: {
        sendInvite: 'Gửi lời mời cho ',
        sendInviteBtn: 'Gửi lời mời',
        yourTasks: 'Nhiệm vụ của bạn ',
        welcomeTo: 'Chào mừng đến với ',
    },
    ar: {
        sendInvite: 'إرسال دعوة لـ ',
        sendInviteBtn: 'إرسال دعوة',
        yourTasks: 'مهامك ',
        welcomeTo: 'مرحبًا بك في ',
    }
};
